import React, {useContext, useState} from 'react';
import LandingPage from './../LandingPage';
import BillingSearchForm from './BillingMapping/BillingSearchForm';
import {ThemeContext} from '../../themes/ThemeProvider';
import AddBillingNew from './BillingMapping/AddBillNew';
function ReportMaster() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [tabLabels, setTabLabels] = useState([]);

  return (
    <div className="billing-indicator-title">
      <LandingPage
        title={'Billing Indicator Maintenance'}
        showTabs={true}
        tabValue={value}
        allAntTabs={tabLabels}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 ? <BillingSearchForm setValue={setValue} 
                  setTabLabels={setTabLabels} /> : value === 1 ? <AddBillingNew setValue={setValue} setTabLabels={setTabLabels}/> : null}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </div>
  );
}

export default ReportMaster;
